/* Playful hand-drawn arrows leading from the preview video down to the opt-in form. */
const ink = { fill: "none", stroke: "currentColor", strokeWidth: 2.2, strokeLinecap: "round", strokeLinejoin: "round" };

export const ArrowsNote = () => (
  <div className="arrows-note" data-testid="arrows-note">
    <svg className="an-svg left" viewBox="0 0 120 110" aria-hidden="true">
      <g filter="url(#ink)"><path {...ink} d="M14 10c28 6 30 34 12 40-14 5-14-16 2-14 22 3 40 28 62 54" /><path {...ink} d="M74 86l17 4-2-17" /></g>
    </svg>
    <div className="an-text">
      <p className="an-script">This was the teaser…</p>
      <p className="an-main">See the <span className="gold-text">whole process</span> in the free masterclass</p>
    </div>
    <svg className="an-svg right" viewBox="0 0 120 110" aria-hidden="true">
      <g filter="url(#ink)"><path {...ink} d="M106 8c-22 10-40 8-46 26-5 16 14 22 18 8 4-15-26-12-34 6-6 14-6 30-10 44" /><path {...ink} d="M22 80l12 14 12-14" /></g>
    </svg>
  </div>
);
